module.exports = __webpack_public_path__ + "img/sticker-learning.036e24c3.svg";